import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button/Button';
import FeedbackPanel from '../FeedbackModal/FeedbackPanel';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import Item from './Item';

/**
Un item di tipo Feedback di `Modal` usato  per chiedere la conferma di lettura di un messaggio.

_Quando si utilizza?_
Può essere utile all'interno di un processo in cui accadono eventi che richiedono una particolare attenzione.

Tramite la modale di feedback si possono veicolare 4 tipologie di messaggi:

- _Informazione_: per comunicare un'informazione utile.
- _Successo_: per informare che qualcosa è avvenuto correttamente.
- _Attenzione_: per avvertire l'utente di una condizione che potrebbe causare problemi in futuro.
- _Allarme/Errore_: per avvertire l'utente di un problema/errore presente.

Con questa, che contiene al suo interno il pulsante "Ho capito",
interrompiamo il flusso di lavoro dell'utente e gli chiediamo di prendere atto di ciò che sta leggendo.

_Attenzione_:
dobbiamo interrompere nel miglior modo possibile e solo quando è veramente necessario,
altrimenti si corre il rischio che l'utente, tempestato di messaggi e popup, che compaiono ad ogni occasione,
si infastidisca, non legga e clicchi subito sul pulsante "Ho capito" senza neanche pensarci su.

Per una questione di facilità di lettura e comprensione i messaggi devono essere sintetici.
Può esserti utile consultare la sezione dedicata ai Testi. Si può anche inserire un link a maggiori dettagli.
*/
const FeedbackItem = ({
  id, modalTitle, buttonLabel, onClose, type, title, message, className, icon,
}) => (
  <Item id={id} className={className}>
    {modalTitle && <Header>{modalTitle}</Header>}
    <Body>
      <FeedbackPanel type={type} title={title} message={message} icon={icon} />
    </Body>
    <Footer>
      <Button emphasis={Button.Emphasis.HIGH} primary onClick={onClose}>{buttonLabel}</Button>
    </Footer>
  </Item>
);

FeedbackItem.propTypes = {
  /** Titolo della modale */
  modalTitle: PropTypes.string,
  /** Etichetta del bottone di chiusura */
  buttonLabel: PropTypes.string,
  /**
   * Identificativo dell'item.
   */
  id: PropTypes.string.isRequired,
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /**
Callback di chiusura della modale.Il primo parametro è l'evento scatenante.
Ritorna un oggetto con `id` pari all'id della modale e
`dontShowAgainId` pari alla prop `dontShowAgainId` della modale.
Per verificate che la chiusura sia conseguenza della gestione dontShowAgain, usare il metodo `Modal.isClosedByDontShowAgainEvent`.
   */
  onClose: PropTypes.func,
  /** Indica la tipologia del feedback */
  type: PropTypes.oneOf(['info', 'alarm', 'warning', 'success']),
  /** Titolo del feedback */
  title: PropTypes.string.isRequired,
  /** messaggio del feedback */
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  /** Indica l'icona da sostituire a quella di default del feedback */
  icon: PropTypes.elementType,
};

FeedbackItem.defaultProps = {
  className: undefined,
  modalTitle: ' ',
  buttonLabel: 'Ho capito',
  onClose: undefined,
  type: 'info',
  icon: undefined,
};

export default FeedbackItem;
